// Allow Webpack to grab all EPOS files in our print images folder and place them into
// a map for lookup by filename. Thanks to https://stackoverflow.com/a/43906442 !
// const encoded_images = ((ctx) => {
//   let keys = ctx.keys()
//   let values = keys.map(ctx)
//   return keys.reduce((o, k, i) => {
//     o[k.substring(2)] = values[i]
//     return o
//   }, {})
// })(require.context('../../static/images/print/', true, /.*\.epos$/))

const epos_timeout = 300_000;
const heartbeat_time = 5_000;
const connection_timeout_ms = 10_000;

export const sendCheckPrinterRequest = ({
  printer_id,
  printer_ip,
  dom_element,
}) => {
  const protocol = "http";
  const req = new XMLHttpRequest();
  const printer_url = `${protocol}://${printer_ip}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=${epos_timeout}`;
  try {
    const connectTimeout = setTimeout(() => {
      try {
        req.abort();
      } catch (err) {}
    }, connection_timeout_ms);

    req.open("OPTIONS", printer_url, true);
    req.overrideMimeType("text/plain");
    req.onreadystatechange = () => {
      if (req.readyState == 4 && req.status == 200) {
        clearTimeout(connectTimeout);
        dom_element.pushEvent("printer-online", {
          printer_id,
          ip_addr: printer_ip,
        });
      }
    };
    req.send();
  } catch (error) {}
};

export const sendLineItemRequest = ({
  printer_ip,
  job_id,
  xml,
  dom_element,
}) => {
  const protocol = "http";
  const req = new XMLHttpRequest();
  const printer_url = `${protocol}://${printer_ip}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=${epos_timeout}`;

  const heartbeat_interval = window.setInterval(() => {
    dom_element.pushEvent("print_heartbeat", { job_id });
  }, heartbeat_time);

  const connect_timeout = setTimeout(() => {
    try {
      req.abort();
      req.onerror();
    } catch (err) {}
  }, connection_timeout_ms);

  try {
    req.open("POST", printer_url, true);
    req.setRequestHeader("Content-Type", "text/xml; charset=utf-8");
    req.onerror = () => {
      dom_element.pushEvent("print_fail", {
        job_id,
        reason: "Browser Network Error",
      });
    };
    req.onloadend = () => {
      window.clearInterval(heartbeat_interval);
      window.clearTimeout(connect_timeout);
    };
    req.onreadystatechange = () => {
      if (req.readyState == 4 && req.status == 200) {
        const res = req.responseXML;
        const responseTag = res.getElementsByTagName("response")[0];
        const success = responseTag.getAttribute("success");
        if (success === "true") {
          dom_element.pushEvent("print_complete", { job_id });
        } else {
          const asb = responseTag.getAttribute("status");
          const errorCode = responseTag.getAttribute("code");
          const reason = `${errorCode}: ${get_printer_error(parseInt(asb))}`;
          dom_element.pushEvent("print_fail", { job_id, reason });
        }
      }
    };
    req.send(populate_images(xml));
  } catch (error) {
    window.clearInterval(heartbeat_interval);
  }
};

const populate_images = (xml) => {
  // Find and replace {{image:<filename>}} content with the EPOS image
  // return xml.replace(/{{image:([\w\.]+)}}/g, (match, filename) => {
  //   return encoded_images[filename + '.epos']
  // })
  return xml;
};

const get_printer_error = (asb) => {
  let msg = "";
  if (asb & 0x00000001) {
    msg += " No printer response\n";
  }
  if (asb & 0x00000008) {
    msg += " Offline status\n";
  }
  if (asb & 0x00000020) {
    msg += " Cover is open\n";
  }
  if (asb & 0x00000040) {
    msg += " Paper feed switch is feeding paper\n";
  }
  if (asb & 0x00000100) {
    msg += " Waiting for online recovery\n";
  }
  if (asb & 0x00000200) {
    msg += " Panel switch is ON\n";
  }
  if (asb & 0x00000400) {
    msg += " Mechanical error generated\n";
  }
  if (asb & 0x00000800) {
    msg += " Auto cutter error generated\n";
  }
  if (asb & 0x00002000) {
    msg += " Unrecoverable error generated\n";
  }
  if (asb & 0x00004000) {
    msg += " Auto recovery error generated\n";
  }
  if (asb & 0x00020000) {
    msg += " No paper in the roll paper near end detector\n";
  }
  if (asb & 0x00080000) {
    msg += " No paper in the roll paper end detector\n";
  }
  if (asb & 0x80000000) {
    msg += " Stop the spooler\n";
  }
  return msg;
};

const Printer = {
  mounted() {
    this.handleEvent("print", (data) => {
      sendLineItemRequest({ ...data, dom_element: this });
    });

    this.handleEvent("check-printer", (data) => {
      sendCheckPrinterRequest({ ...data, dom_element: this });
    });
  },
};

export default Printer;
